module.exports = __webpack_public_path__ + "img/4.ff7e25ab.jpg";